import request from '@/utils/request'

// ==================== 系统功能接口 ====================

/**
 * 生成授权证书
 * @param {Object} data - 证书生成参数
 * @returns {Promise}
 */
export function generateAuthorizationCertificate(data) {
  return request({
    url: '/system/certificates/authorization',
    method: 'post',
    data
  })
}

/**
 * 为门店生成并绑定授权证书
 * @param {string} storeId - 门店ID
 * @param {Object} data - 证书生成参数
 * @returns {Promise}
 */
export function generateStoreAuthorizationCertificate(storeId, data) {
  return request({
    url: `/system/certificates/authorization/store/${storeId}`,
    method: 'post',
    data
  })
}

/**
 * 获取公告统计信息
 * @param {number} announcementId - 公告ID
 * @returns {Promise}
 */
export function getAnnouncementStatistics(announcementId) {
  return request({
    url: `/announcements/${announcementId}/statistics`,
    method: 'get'
  })
}

/**
 * 下载授权证书
 * @param {string} downloadUrl - 下载地址
 * @returns {Promise}
 */
export function downloadCertificate(downloadUrl) {
  return request({
    url: downloadUrl,
    method: 'get',
    responseType: 'blob'
  })
}
